import React from 'react';

import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { AppWrapper } from './Style';

import Header from './components/Header/Header';
import Home from './pages/Home';
import Info from './pages/Info';

// Art pages
import Palette from './pages/art/Palette';

// Product pages
import multiAutomation from './pages/product/multiAutomation'

const App = () => {
  return (
    <AppWrapper >
      <BrowserRouter>
        <Header />
            <Switch>
              <Route path='/' exact component={Home} />
              <Route path='/info' exact component={Info} />

              <Route path='/palette' exact component={Palette} />

              <Route path='/multi-automation' exact component={multiAutomation} />

            </Switch>
      </BrowserRouter>
    </AppWrapper>
  );
};

export default App;
